/* eslint-disable react/prop-types */ // TODO: add props
import PropTypes from 'prop-types';
import { Component } from 'react';
import classNames from 'classnames';

class PercentageIndicator extends Component {
  static defaultProps = {
    orientation: 'vertical',
    showValue: true,
  };

  static propTypes = {
    // value: React.PropTypes.number,
    orientation: PropTypes.oneOf(['vertical', 'horizontal']),
    showValue: PropTypes.bool,
  };

  percentage() {
    if (!this.props.value) {
      return '0%';
    }
    return `${Math.round(this.props.value * 10) / 10}%`;
  }

  render() {
    let style = {};

    if (this.props.orientation === 'horizontal') {
      style = {
        width: this.percentage(),
      };
    } else {
      style = {
        height: this.percentage(),
      };
    }

    return (
      <div
        className={classNames('percentage-indicator', this.props.orientation)}
      >
        {this.props.showValue && (
          <span className="value">
            {this.props.value ? this.percentage() : '-'}
          </span>
        )}
        <div
          className={classNames('indicator', this.props.className)}
          style={style}
        />
      </div>
    );
  }
}

export default PercentageIndicator;
